var project = require('../../settings');
var utils = require('./modules/utils');
var Packery = require('packery');
var Cookies = require('js-cookie');

window.ThemeUtils = utils;

/* Event Handlers  */
(function ($, $PB) {
    var scroll_offset = -50;
    var scroll_speed = 1000;
    var ie = KMDGPB.builder.detectIE();

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        //Tile Card layout
        utils.equalHeight('.tile-card__img', '.builder-layout');
        utils.equalHeight('.tile-card__content', '.builder-layout');
        utils.equalHeight('.equal-height--accordion', '.builder-layout');
        utils.equalHeight('.tile-card__top', '.builder-layout');
        //Component layout adjustments
        utils.equalHeight('.builder-component-business-card', '.builder-layout');
        utils.equalHeight('.post-title', '.builder-table');
        //Custom post type adjustments
        utils.equalHeight('.single_tile__name', '.resource_tiles');

        utils.equalHeight('.resource--type-meta', '.resource--related-posts');
        utils.equalHeight('.resource--post-title', '.resource--related-posts');

        //Divided Vertical Columns
        utils.equalHeight('.divided_columns__header', '.divided_columns__wrapper');
        utils.equalHeight('.divided_columns__subhead', '.divided_columns__wrapper');
        utils.equalHeight('.divided_columns__content', '.divided_columns__wrapper');


        utils.equalHeight('.js-equal');
        $(window).trigger('resize').trigger('scroll');

        if (ie) {
            $('html').addClass('ms_ie').addClass('ms_ie' + ie);
        }

        setInterval(function () {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    //Header top spacer
    $(window).on('resize', function () {
        var padding = $('.site_header').outerHeight(); //+ parseFloat($('.builder-section:first').css('padding-bottom'));

        $('.builder-section:first').css('padding-top', padding);
        $('.builder-section:first').css('padding-bottom', padding);
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            "searchfield": {
                "search": false,
            },
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }, {
            offCanvas: {
                pageNodetype: 'div#page.site-wrapper'
            },
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's'
                }
            }
        }
    );

    $(document).ready(function () {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.tabs-container ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.tabs-container ul.tabs-wrap li').on('click', function () {
        var $tab_id = $(this).attr('data-tab');

        $('.tabs-container ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#" + $tab_id).addClass('open');

    });

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    $PB('.builder-component-ticker-counter').on('builderAnimationStart', function () {
        var $this = $(this),
            $number = $this.find('.single-counter .number'),
            countTo = $number.attr('data-count'),
            delay = $this.attr('data-animation-delay') * 1000;

        setTimeout(function () {
            $({
                countNum: 0
            }).animate({
                    countNum: countTo
                },

                {
                    duration: 4000,
                    easing: 'linear',
                    step: function () {
                        $number.text(commaSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function () {
                        $number.text(commaSeparateNumber(this.countNum));
                    }
                }
            );
        }, delay);
    });

    //Tab Box JS
    $('.builder-layout-tab-box .tab').on('click', function () {
        var num = $(this).attr('data-tab');
        var $parent = $(this).parents('.builder-layout');
        var $tabs = $parent.find('.builder-tabs');
        var $content = $parent.find('.builder-tabs--content');

        $content.find('.tab--content').removeClass('active').addClass('off');
        $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

        $tabs.find('.overtab').removeClass('active').addClass('off');
        $(this).parents('.overtab').addClass('active').removeClass('off');
    });


    //Accordion JS
    $('.single-accordion .accordion-header').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('.accordion-inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });

    $('.single_accordion .single_accordion__header').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('.single_accordion__inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });

    $('.image-container').on("hover", function () {
        $('.image-container')
    });

    function youtube_parser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

    //Search Bar open/close
    $('.search-bar .search-button').on('click', function () {
        $(this).parent().toggleClass('open');
    });

    var top = 1; // Trigger on any scrolling

    $(document).scroll(function () {
        var scrollPos = $(document).scrollTop();
        if (top && scrollPos >= top) {
            $('.site_header').addClass('scrollColor');
        } else if (top && scrollPos < top) {
            $('.site_header').removeClass('scrollColor');
        }
    });

    $('.resource--type-link').on('click', function (e) {
        e.preventDefault();
        $('.resource--type-link').removeClass('active');
        kmdgResourceCenter.fn.setHashData('type', $(this).attr('data-friendly'));
        kmdgResourceCenter.fn.setHashData('page', 1);
    });


    //Header hover effect at top of screen
    var isHovering = false;

    $(".header-row").on('mouseenter', function () {
        isHovering = true;
        debounce(500, true, checkHoverState)();
    });
    $(".header-row").on('mouseleave', function () {
        isHovering = false;
        debounce(500, false, checkHoverState)();
    });

    $(".inner-container").on('mouseenter', function () {
        isHovering = true;
        debounce(500, true, checkHoverState)();
    });
    $(".inner-container").on('mouseleave', function () {
        isHovering = false;
        debounce(500, false, checkHoverState)();
    });

    function debounce(wait, immediate, func) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function checkHoverState() {
        if (isHovering) {
            $('.site_header').addClass('header_hover');
        } else {
            $('.site_header').removeClass('header_hover');
        }
    }

    //Equalizing heights of RC items after full load
    $(window).on('kmdg_rc_render_posts', function () {
        utils.equalHeight('.resource--type-meta', '.resource--search-results');
        utils.equalHeight('.resource--post-subtitle--wrap', '.resource--search-results');
        utils.equalHeight('.resource--post-title', '.resource--search-results');
        utils.equalHeight('.resource--content-wrapper', '.resource--search-results');
    });

    if (location.hash) {
        utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed);
    }

    $(window).on('hashchange', function (e) {
        if (location.hash) {
            if (!utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed)) {
                e.preventDefault();
            }
        }
    });

    $PB(window).on('builderAnimationStart', function (e, el) {
        if ($(el).is('.builder-component-image')) {
            $(el).find('.builder-image-caption').addClass('shown');
        }
    });

    //pop up cta after load timer off temporarily
    $(window).on('load', function () {
        // if (Cookies.get('popup-cta') != 'closed') {
        //     setTimeout(function () {
        //         $('.popup_cta').addClass('active');
        //     }, 10000)
        // }

        $(document).mouseleave(function () {
            if (Cookies.get('popup-cta') != 'closed') {
                $('.popup_cta').addClass('active');
            }
        });
    });

    $('.popup_cta .popup_cta__exit').on('click', function () {
        $(this).parents().removeClass('active');
        Cookies.set('popup-cta', 'closed');
    });

})(jQuery, KMDGPB.jQuery);